import classNames from 'classnames';
import Button from 'components/styleguide/button/Button';
import Icon from 'components/styleguide/icon/Icon';
import IconButton from 'components/styleguide/icon_button/IconButton';
import React, { useState } from 'react';

const styles = require('./Toast.module.scss');

export type ToastVariant = 'info' | 'success' | 'warning' | 'error';

const ICON_NAME: Record<ToastVariant, string> = {
  info: 'info',
  success: 'circleCheck',
  warning: 'circleAlert',
  error: 'triangleAlert',
};

export interface ToastProps {
  buttonLabel?: string;
  className?: string;
  closeLabel?: string;
  message: string;
  onButtonClick?: () => void;
  onClose?: () => void;
  variant?: ToastVariant;
}

const Toast: React.FC<ToastProps> = ({
  buttonLabel,
  className,
  closeLabel = 'Dismiss',
  message,
  onButtonClick,
  onClose,
  variant = 'info',
}) => {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  const handleClose = () => {
    setIsVisible(false);
    onClose?.();
  };

  return (
    <div
      className={classNames(styles.toast, styles[variant], className)}
      role={variant === 'error' || variant === 'warning' ? 'alert' : 'status'}
    >
      <span className={styles.iconWrapper}>
        <Icon
          name={ICON_NAME[variant]}
          size="md"
          color={`${variant}-border-base`}
          aria-hidden="true"
        />
      </span>
      <div className={styles.body}>
        <span className={styles.message}>{message}</span>
        {buttonLabel && (
          <Button
            type="terceary"
            size="S"
            context="neutral"
            className={styles.actionButton}
            onClick={onButtonClick}
          >
            {buttonLabel}
          </Button>
        )}
      </div>
      <IconButton
        iconName="x"
        size="S"
        type="terceary"
        context="neutral"
        aria-label={closeLabel}
        onClick={handleClose}
        className={styles.closeButton}
      />
    </div>
  );
};

export default Toast;
